import React, { useState } from 'react';
import './Portfolio.css';

const Portfolio = () => {
  const [showMore, setShowMore] = useState(false);

  const projects = [
    { 
      id: 1, 
      name: 'VidQuill – YouTube SEO Tool', 
      image: './Projects-img/vidquill.PNG', 
      name_dsc: 'A project description for VidQuill', 
      tech: 'Springboot, React, MySql', 
      link: 'https://www.vidquill.com'
    },
    { 
      id: 2, 
      name: 'Secure JWT Auth Backend System', 
      image: './Projects-img/auth.PNG', 
      name_dsc: 'A project description for project 2', 
      tech: 'Node.js, Express.js, MongoDB, Postman', 
      link: 'https://github.com/LakshanHewagama/JWT-Auth.git'
    },
    { 
      id: 3, 
      name: 'Ayurweda Management System', 
      image: './Projects-img/ayurwedha.PNG', 
      name_dsc: 'A project description for project 2', 
      tech: 'Springboot, React, MySql', 
      link: 'https://github.com/RavinduRukshan/AyurvedaManagement.git'
    },
    { 
      id: 4, 
      name: 'Tuition Class Management System', 
      image: './Projects-img/sadana.PNG', 
      name_dsc: 'A project description for project 2', 
      tech: 'Laravel, HTML, CSS, MySQL', 
      link: 'https://github.com/LakshanHewagama/Sadana_TCMS.git'
    },
    { 
      id: 5, 
      name: 'Portfolio', 
      image: './Projects-img/portfolio.PNG', 
      name_dsc: 'A project description for project 2', 
      tech: 'React', 
      link: 'https://lakshanhewagama.vercel.app/'
    },
    { 
      id: 6, 
      name: 'Laravel To Do App', 
      image:  './Projects-img/todo.PNG', 
      name_dsc:'This is a web app built with Laravel.', 
      tech: 'Laravel, HTML, CSS, MySQL', 
      link: 'https://github.com/LakshanHewagama/Laravel_ToDo_App.git'
    },
    { 
      id: 7, 
      name: 'E Payment Tracker', 
      image: './Projects-img/epaymenttracker.PNG', 
      name_dsc: 'A project description for project 2', 
      tech: 'Laravel, HTML, CSS, MySQL', 
      link: 'https://github.com/LakshanHewagama/E-Payment-Tracker.git'
    },

    { 
      id: 8, 
      name: 'Age Calculator', 
      image: './Projects-img/agecalculater.PNG', 
      name_dsc: 'A project description for project 2', 
      tech: 'HTML, CSS, Java Sripts', 
      link: 'https://github.com/LakshanHewagama/JS-Age-Calculator.git'
    },

    { 
      id: 9, 
      name: 'Calculator', 
      image: './Projects-img/calculater.PNG', 
      name_dsc: 'A project description for project 3', 
      tech: 'HTML, CSS, Java Sripts', 
      link: 'https://github.com/LakshanHewagama/JS-Age-Calculator.git'
    },
    { 
      id: 10, 
      name: 'Weather App', 
      image: './Projects-img/weatherapp.PNG', 
      name_dsc: 'A project description for project 4', 
      tech: 'HTML, CSS, Java Sripts, Weather API', 
      link: 'https://github.com/LakshanHewagama/JS-Weather-App.git'
    },
    { 
      id: 11, 
      name: 'New Year Countdown Timer', 
      image: './Projects-img/timer.PNG', 
      name_dsc: 'A project description for project 5', 
      tech: 'HTML, CSS, Java Sripts', 
      link: 'https://github.com/LakshanHewagama/JS-New-Year_Countdown.git'
    },
    
    // { 
    //   id: 6, 
    //   name: 'Project 6', 
    //   image: 'project6.png', 
    //   name_dsc: 'A project description for project 6', 
    //   tech: 'Django, PostgreSQL', 
    //   link: 'https://www.example.com/project6'
    // },
    // { 
    //   id: 7, 
    //   name: 'Project 7', 
    //   image: 'project7.png', 
    //   name_dsc: 'A project description for project 7', 
    //   tech: 'Express.js, MongoDB', 
    //   link: 'https://www.example.com/project7'
    // },
    // { 
    //   id: 8, 
    //   name: 'Project 8', 
    //   image: 'project8.png', 
    //   name_dsc: 'A project description for project 8', 
    //   tech: 'PHP, Laravel', 
    //   link: 'https://www.example.com/project8'
    // },
    // { 
    //   id: 9, 
    //   name: 'Project 9', 
    //   image: 'project9.png', 
    //   name_dsc: 'A project description for project 9', 
    //   tech: 'React, Node.js', 
    //   link: 'https://www.example.com/project9'
    // },
    // { 
    //   id: 10, 
    //   name: 'Project 10', 
    //   image: 'project10.png', 
    //   name_dsc: 'A project description for project 10', 
    //   tech: 'JavaScript, HTML, CSS', 
    //   link: 'https://www.example.com/project10'
    // },
  ];

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  return (
    <section className='portfolio' id='portfolio'>
      <h2 className='heading'>Latest <span>Projects</span></h2>

      <div className='portfolio-container'>
        {/* Display the first 6 projects */}
        {projects.slice(0, 6).map((project) => (
          <div className='portfolio-box' key={project.id}>
            <img src={project.image} alt={project.name} />
            <div className='portfolio-layer'>
              <h4>{project.name}</h4>
              {/* <p>{project.name_dsc}</p> */}
              {/* <h4>Used Technology</h4> */}
              <p>{project.tech}</p>
              <a href={project.link} target="_blank" rel="noopener noreferrer">
                <i className="fa-solid fa-up-right-from-square"></i>
              </a>
            </div>
          </div>
        ))}

        {/* Conditionally render the "Show More" projects */}
        {showMore && 
          projects.slice(6).map((project) => (
            <div className='portfolio-box' key={project.id}>
              <img src={project.image} alt={project.name} />
              <div className='portfolio-layer'>
                <h4>{project.name}</h4>
                {/* <p>{project.name_dsc}</p>               */}
                {/* <h4>Used Technology:</h4> */}
                <p>{project.tech}</p>
                <a href={project.link} target="_blank" rel="noopener noreferrer">
                  <i className="fa-solid fa-up-right-from-square"></i>
                </a>
              </div>
            </div>
          ))
        }
      </div>

      <div className='show-more' onClick={toggleShowMore}>
        {showMore ? 'Show Less Projects' : 'More Projects'}
        <i className={`fa-solid fa-caret-${showMore ? 'up' : 'down'}`}></i>
      </div>
    </section>
  );
};

export default Portfolio;
